<template>
  <div>
    <!--客戶列表-->
    <header class="form-title">
      <Row>
        <Col span="22">
          <Form inline :label-width="80">
            <FormItem label="客户姓名">
              <Input v-model="sendData.name" style="width: 200px" />
            </FormItem>
            <FormItem label="手机号">
              <Input v-model="sendData.phone"  style="width: 200px" />
              <label style="margin-left: 30px;margin-right: 10px;">客户分类</label>
              <Select style="width: 100px;" v-model="sendData.customerStatus">
               
                <Option value="0">全部</Option>
                <Option value="1">主客户</Option>
                <Option value="2">子客户</Option>
              </Select>
              <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="2">
          <Button type="primary" @click="addcomlist">
            <Icon type="md-add" />添加客户
          </Button>
        </Col>
      </Row>
    </header>
    <section>
      <Alert v-if="customerList==''" align="center">暂无数据</Alert>
      <ul class="card">
        <li
          style="padding: 20px 15px;cursor: pointer;"
          v-for="(item,index) in customerList"
          :key="index"
          @click="editModal(item)"
        >
          <ButtonGroup class="butn" size="small" v-if="item.username==null">
            <Button type="primary" ghost @click.stop="opwindh(item)">
              <img src="../../assets/img/blue.png" style="width: 20px; display: inline;position: relative;top: 2px;left: -2px">
                 <span style="position: relative;top: -3px;left: -2px">会员</span>
            </Button>
            <Button type="primary" ghost @click.stop="opwindj(item)">
              <img src="../../assets/img/blue.png" style="width: 20px; display: inline;position: relative;top:2px;left: -2px">
               <span style="position: relative;top: -3px;left: -2px">积分</span>
            </Button>
            <Button type="primary" ghost @click.stop="delcustomer(item)">删除</Button>



          </ButtonGroup>
          <Row>
            <Col span="12">
              <h3>
                <Tag color="warning" v-if="item.customerType==0">零售</Tag>
                <Tag color="success" v-if="item.customerType==1">批发</Tag>
                <span v-if="item.superCustomerid==null" >{{item.name}}</span>
                <span v-if="item.superCustomerid==1" style="background-color: #ffa800;">{{item.name}}</span>
                <span v-if="item.superCustomerid>1" style="background-color: yellowgreen;">{{item.name}}</span>
              </h3>
              <p style="padding: 6px 0" v-if="item.phone!=''">电话:{{item.phone}}</p>
              <p>{{item.membertime}}</p>
            </Col>
            <Col span="12">
              <p>客户余额</p>
              <strong>
                <span v-if="item.money>0">￥ -{{item.money}}</span>
                <span v-else>￥ {{Math.abs(item.money)}}</span>
              </strong>
              <p>会员卡余额</p>
              <strong>￥ {{item.balance}}</strong>
            </Col>
          </Row>
        </li>
      </ul>
    </section>
    <div class="pageTotal" v-if="customerList!=''">
      <Page :total="page.total" show-total :page-size="page.rows" @on-change="onGongPageTotal" />
    </div>
    <Modal v-model="winda" title="会员充值">
      <div>
        <Form inline :label-width="80">
          <FormItem label="客户">
            <Input type="text" v-model="windaData.username" style="width: 300px" disabled></Input>
          </FormItem>
          <FormItem label="余额">
            <strong style="color: #ffa800">￥{{windaData.Surplus}}</strong>
          </FormItem>
          <FormItem label="充值">
            <InputNumber
              v-model.trim="windaData.pullmoney"
              :max="99999999"
              :min="0"
              style="width: 300px"
            ></InputNumber>
          </FormItem>
          <FormItem label="赠送">
            <InputNumber
              v-model.trim="windaData.givemoney"
              :max="99999999"
              :min="0"
              style="width: 300px"
            ></InputNumber>
          </FormItem>
          <FormItem label="结算账户">
            <Select v-model="windaData.Pay" class="formSelect-input" style="width: 300px">
              <Option :value="k.type" v-for="(k,v) in bankList" :key="v">{{k.bankname}}</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="ok">确定</Button>
      </div>
    </Modal>
    <Modal v-model="windb" title="积分调整">
      <div>
        <Form inline :label-width="100">
          <FormItem label="客户">
            <Input type="text" v-model="windbData.username" style="width: 300px" disabled></Input>
          </FormItem>
          <FormItem label="当前积分">
            <strong style="color: #ffa800">{{windbData.jifen}}</strong>
          </FormItem>
          <FormItem label="增加客户积分">
            <InputNumber
              v-model.trim="windbData.addjifen"
              :disabled="isshowThisa"
              :max="99999999"
              :min="0"
              style="width: 300px"
            ></InputNumber>
          </FormItem>
          <FormItem label="减少客户积分">
            <InputNumber
              v-model.trim="windbData.jjifen"
              :disabled="isshowThisb"
              :max="99999999"
              :min="0"
              style="width: 300px"
            ></InputNumber>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="okjf">确定</Button>
      </div>
    </Modal>
    <!--添加客户-->
    <Modal v-model="addkehu" title="添加客户">
      <div>
        <Form inline :label-width="100">
          <FormItem label="名称">
            <Input
              type="text"
              v-model.trim="kehuData.username"
              placeholder="请输入客户名称(必填项)"
              style="width: 19rem"
            ></Input>
          </FormItem>
          <FormItem label="手机号">
            <Input
              :maxlength="20"
              show-word-limit
              v-model.trim="kehuData.phone"
              placeholder="请输入手机号(必填项)"
              style="width: 19rem"
            ></Input>
          </FormItem>
          <FormItem label="生日">
            <div @click="birthdayOn_Off=true">
              <Input
              @click="birthdayOn_Off=true"
                v-model="kehuData.birthday"
                disabled
                placeholder="生日"
                style="width: 19rem;"
              >            
              </Input>
            </div>    
            <div class="datetimePicker" v-if="birthdayOn_Off">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择生日"
                item-height="2rem"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="selectBirthday"
                @cancel="offSelectBirthday"
              />
            </div>  
          </FormItem>
          <FormItem label="地址">
            <Input
              type="text"
              v-model.trim="kehuData.address"
              placeholder="地址"
              style="width: 19rem"
            ></Input>
          </FormItem>
          <FormItem label="开户银行">
            <Input type="text" v-model.trim="kehuData.bank" placeholder="开户银行" style="width: 19rem"></Input>
          </FormItem>
          <FormItem label="银行账号">
            <Input
              type="text"
              v-model.trim="kehuData.bankaccount"
              placeholder="银行账号"
              style="width: 19rem"
            ></Input>
          </FormItem>
          <FormItem label="客户类别">
            <RadioGroup v-model="kehuData.type">
              <Radio label="1">批发客户</Radio>
              <Radio label="0">零售客户</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="备注">
            <Input
              type="textarea"
              v-model="kehuData.remark"
              :maxlength="50"
              placeholder="备注(最多输入50个字符)"
              style="width: 19rem"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="addkehuok" :loading="addsSelectItemloading">
          <span v-if="!addsSelectItemloading">确定</span>
          <span v-else>加载中</span>
        </Button>
      </div>
    </Modal>
    <!--客户详情-->
    <Modal v-model="editcustomer" title="客户详情">
      <div>
        <Form :label-width="100">
          <FormItem label="姓名">
            <Input
              type="text"
              style="width: 19rem"
              v-model="selectCustomer.name"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
          <FormItem label="电话">
            <Input
              :maxlength="20"
              show-word-limit
              style="width: 19rem"
              v-model="selectCustomer.phone"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
          <FormItem label="生日">
            <div @click="birthdayOn_Off=true">
              <Input
              @click="birthdayOn_Off=true"
                v-model="selectCustomer.birthday"
                disabled
                placeholder="生日"
                style="width: 19rem;"
              >            
              </Input>
            </div>    
            <div class="datetimePicker" v-if="birthdayOn_Off">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择生日"
                item-height="2rem"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="selectBirthdayUp"
                @cancel="offSelectBirthdayUp"
              />
            </div>  
          </FormItem>          
          <FormItem label="地址">
            <Input
              type="text"
              style="width: 19rem"
              v-model="selectCustomer.address"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
          <FormItem label="开户银行">
            <Input
              type="text"
              style="width: 19rem"
              v-model="selectCustomer.bank"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
          <FormItem label="银行账号">
            <Input
              type="text"
              style="width: 19rem"
              v-model="selectCustomer.bankcode"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
          <FormItem label="客户类别">
            <RadioGroup v-model="selectCustomer.customerType">
              <Radio :label="1" :value="1" :disabled="isDisabled">批发客户</Radio>
              <Radio :label="0" :value="0" :disabled="isDisabled">零售客户</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="总余额">
            <router-link :to="'/paymentbill?cusId='+selectCustomer.id">
              <span style="color:#2b9173">
                {{0-selectCustomer.money}}
                <Icon type="ios-arrow-forward" />
              </span>
            </router-link>
          </FormItem>
          <FormItem label="会员充值">
          <div  @click="goselectCustomer(selectCustomer.id)" style="cursor: pointer">       <!--   :to="'/recode?cusId='+selectCustomer.id"-->
              <span style="color:#ffa800">
                {{selectCustomer.balance}}
                <Icon type="ios-arrow-forward" />
              </span>
            </div>
          </FormItem>
          <FormItem label="客户积分">
            <router-link :to="'/jfdetail?cusId='+selectCustomer.id">
              <span style="color:#ffa800">
                {{selectCustomer.integral}}
                <Icon type="ios-arrow-forward" />
              </span>
            </router-link>
          </FormItem>
          <FormItem label="备注">
            <Input
              type="textarea"
              v-model="selectCustomer.remark"
              :maxlength="50"
              placeholder="备注(最多输入50个字符)"
              style="width: 300px"
              :disabled="isDisabled"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="editcustomerFn" :loading="addsSelectItemloading">
          <span v-if="!addsSelectItemloading">保存</span>
          <span v-else>加载中</span>
        </Button>
        <router-link to="/newSale" style="margin:0 5px">
          <Button type="success">
            <span>开单</span>
          </Button>
        </router-link>
          <!--    :to="'/customerAnalysis?cusId='+selectCustomer.id"-->
          <Button  @click="customerAnalysis(selectCustomer.id)">
            <img src="../../assets/img/blue.png" style="width: 20px; display: inline;position: relative;top: 5px;left: -2px">
            <span>分析</span>
          </Button>

      </div>
    </Modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { DatetimePicker } from 'vant';
import 'vant/lib/index.css';
Vue.use(DatetimePicker);
export default {
  data() {
    return {
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2030, 10, 1),
      currentDate: new Date(1990, 9, 1),
      birthdayOn_Off:false,

      cid: "",
      sid: "",
      winda: false,
      windb: false,
      addkehu: false,
      isshowThisa: false,
      isshowThisb: false,
      addsSelectItemloading: false,
      pageData: {},
      bankList: [],
      sendData: {
        name: "",
        phone:''
      },
      windaData: {
        id: "162",
        username: "",
        Surplus: "",
        pullmoney: 0,
        givemoney: 0,
        Pay: "",
        creatorId: ""
      },
      windbData: {
        id: "",
        jifen: "",
        username: "",
        addjifen: 0,
        jjifen: 0
      },
      kehuData: {
        username: "",
        phone: "",
        address: "",
        bank: "",
        bankaccount: "",
        type: "1",
        remark: "",
        birthday:""
      },
      customerList: [],
      page: {
        total: 0,
        page: 1,
        rows: 12
      },
      editcustomer: false,
      // 选中的客户
      selectCustomer: {},
      isDisabled: false
    };
  },
  created: function() {
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;

    this.getCustomerList();
  },
  watch: {
    "sendData.name": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.getCustomerList();
      }
    },
    "sendData.phone": {
      deep: true,
      handler: function(newVal, oldVal) {
        this.getCustomerList();
      }
    },
    "windbData.addjifen": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (newVal > 0) {
          this.isshowThisb = true;
        } else {
          this.isshowThisb = false;
        }
      }
    },
    "windbData.jjifen": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (newVal > 0) {
          this.isshowThisa = true;
        } else {
          this.isshowThisa = false;
        }
      }
    }
  },
  methods: {
    selectBirthday (value) {
      this.birthdayOn_Off = false;
      this.kehuData.birthday = this.formatter(value,"yyyy-MM-dd");
    },
    offSelectBirthday () {
      this.birthdayOn_Off = false;
    },       
    selectBirthdayUp (value) {
      this.birthdayOn_Off = false;
      this.selectCustomer.birthday = this.formatter(value,"yyyy-MM-dd");
    },
    offSelectBirthdayUp () {
      this.birthdayOn_Off = false;
    },       
    //客户分析
    customerAnalysis(id){
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");
      var flag = 0;
      shopArray.forEach(item => {
        if (item == "100051" || item == "100060") { //100051皇冠  100060蓝钻 100059黄钻
          this.$router.push({
            path:'/customerAnalysis?cusId='+id
          })
          flag = 1;
        }
      });
      if (flag == 0) {
        this.$Message.info("亲,你还未购买此服务，暂时不能访问!");
      }

    },
    //充值记录
    goselectCustomer(id){
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");
      var flag = 0;
      shopArray.forEach(item => {
        if (item == "100051" || item == "100060") { //100051皇冠  100060蓝钻 100059黄钻
          this.$router.push({
            path:'/recode?cusId='+id
          })
          flag = 1;
        }
      });
      if (flag == 0) {
        this.$Message.info("亲,你还未购买此服务，暂时不能访问!");
      }
    },



    //客户列表
    getCustomerList() {
      this.$Api
        .getCustomerList({
          cid: this.cid,
          sid: this.sid,
          page: this.page.page,
          rows: this.page.rows,
          isdel: 1,
          name: this.sendData.name,
          phone: this.sendData.phone,
          customerStatus:this.sendData.customerStatus
        })
        .then(res => {
          if (res.code == 200) {
            this.page.total = res.count;
            this.customerList = res.data;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    onGongPageTotal(num) {
      this.page.page = num;
      this.getCustomerList(this.page.page, this.page.rows);
    },
    searchCondition() {
      this.getCustomerList(this.page.page, this.page.rows);
    },
    //获取银行卡
    getBankList() {
      this.$Api
        .getBankList({
          cid: this.cid,
          sid: this.sid,
          page: 1,
          rows: 1000
        })
        .then(res => {
          if (res.code == 200) {
            this.bankList = [];
            res.data.forEach(item => {
              if (item.type != 6) {
                this.bankList.push(item);
              }
            });
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    /**
     * opwind会员
     * **/
    opwindh(data) {
      var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
      if (!PermisCode.includes("8")) {
        this.$Message.info("暂无权限");
        return;
      }
      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");

      var flag = 0;
      shopArray.forEach(item => {
        if (item == "100051" || item == "100060") { //100051皇冠  100060蓝钻 100059黄钻
              if (data.username == null) {
                this.winda = true;
                this.windaData.id = data.id;
                this.windaData.username = data.name;
                this.windaData.Surplus = data.balance;
                this.windaData.creatorId = data.cid;
                this.getBankList();
              } else {
                this.$Message.info("默认客户，不能进行该操作");
              }
          flag = 1;
        }
      });
      if (flag == 0) {
        this.$Message.info("亲,你还未购买此服务，暂时不能访问!");
      }
    },
    opwindj(data) {


      var shop = JSON.parse(localStorage.getItem("shop")).code;
      var shopArray = shop.split(",");

      var flag = 0;
      shopArray.forEach(item => {
        if (item == "100051" || item == "100060") { //100051皇冠  100060蓝钻 100059黄钻
          if (data.username == null) {
            var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
            if (PermisCode.includes("80")) {
              this.windb = true;
              this.windbData.id = data.id;
              this.windbData.username = data.name;
              this.windbData.jifen = data.integral;
            } else {
              this.$Message.info("暂无权限");
              return;
            }
          } else {
            this.$Message.info("默认客户，不能进行该操作");
          }
          flag = 1;
        }
      });
      if (flag == 0) {
        this.$Message.info("亲,你还未购买此服务，暂时不能访问!");
      }

    },
    /** 删除客户 **/
    delcustomer(item){
      /*var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
      if(!PermisCode.includes("48")){
        this.$Message.info("暂无权限");
        return
      }*/
      this.$Modal.confirm({
        title: '提示信息',
        content: '如果该客户已使用不能删除，将被禁用',
        loading: true,
        onOk:() =>{
          this.$Api.isdelCustomer({
            id:item.id,
            isdel: "0"
          }).then(res => {
            if(res.code==200){
              this.$Message.success("删除成功");
              this.getCustomerList(this.page.page, this.page.rows);
            }else {
              this.$Message.warning(res.msg);
            }
          });
          this.$Modal.remove()
        }
      });
    },



    okjf() {
      if (this.windbData.addjifen == "" && this.windbData.jjifen == "") {
        this.$Message.info("至少输入一个");
        return;
      }
      if (this.windbData.addjifen > 0) {
        this.windbData.jjifen = 0;
      }
      if (this.windbData.jjifen > 0) {
        this.windbData.addjifen = 0;
      }
      this.$Api
        .updateIntegralRecord({
          customerid: this.windbData.id,
          addintegral: this.windbData.addjifen,
          reduceintegral: this.windbData.jjifen,
          addbyadminid: JSON.parse(localStorage.getItem("adminUser")).id
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success("调整成功");
            this.windb = false;
            this.windaData = {};
            this.windbData.addjifen = 0;
            this.windbData.jjifen = 0;
            this.getCustomerList();
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },

    /*充钱*/
    ok() {
      if (this.windaData.pullmoney == "") {
        this.$Message.info("请输入充值金额");
        return;
      }
      if (this.windaData.Pay == "") {
        this.$Message.info("请选择结算账户");
        return;
      }
      if(!this.windaData.givemoney){
          this.windaData.givemoney=0
      }
      this.$Api
        .recharge({
          id: this.windaData.id,
          recharge: this.windaData.pullmoney,
          present: this.windaData.givemoney,
          payType: this.windaData.Pay,
          creatorId: this.windaData.creatorId
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success("充值成功");
            this.windaData.pullmoney = "";
            this.windaData.givemoney = "";
            this.winda = false;
            this.getCustomerList();
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },

    /**
     * 添加客户
     * **/
    addkehuok() {
      if (this.kehuData.username == "") {
        this.$Message.info("名称不能为空");
        return;
      }
      if (this.kehuData.phone == "") {
        this.$Message.info("手机号不能为空");
        return;
      }
      // var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
      // if (!telTest.test(this.kehuData.phone)) {
      //   this.$Message.info("请输入正确的手机号码");
      //   return;
      // }

      this.addsSelectItemloading = this;
      this.$Api
        .addCustomer({
          ismatter: 1,
          customerType: this.kehuData.type,
          cid: this.cid,
          sid: this.sid,
          name: this.kehuData.username,
          phone: this.kehuData.phone,
          address: this.kehuData.address,
          bank: this.kehuData.bank,
          bankcode: this.kehuData.bankaccount,
          remark: this.kehuData.remark,
          birthday: this.kehuData.birthday
        })
        .then(res => {
          if (res.code == 200) {
            this.addkehu = false;
            this.$Message.success("添加成功");
            this.getCustomerList();
            this.kehuData = {};
          } else {
            this.$Message.warning(res.msg);
          }
          this.addsSelectItemloading = false;
        })
        .catch(err => {
          this.$Message.warning(err.msg);
          this.addsSelectItemloading = false;
        });
    },

    //添加客户弹框
    addcomlist() {
      var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
      if (PermisCode.includes("48")) {
        this.addkehu = true;
      } else {
        this.$Message.info("暂无权限");
      }
    },
    //打开客户详情
    editModal(item) {
      this.selectCustomer = item;
      if (item.username == "零售散客" || item.username == "批发散客") {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      this.editcustomer = true;
    },
    editcustomerFn() {
      if (
        this.selectCustomer.username == "零售散客" ||
        this.selectCustomer.username == "批发散客"
      ) {
        this.$Message.error("系统默认客户，不能进行修改！");
        return;
      } else if (this.selectCustomer.isdel != "1") {
        this.$Message.error("该客户已禁用，不能进行该操作！");
        return;
      }
      let selectCustomer = Object.assign({}, this.selectCustomer);
      let form = {
        cid: this.cid,
        sid: this.sid,
        id: selectCustomer.id,
        ismatter: selectCustomer.isdel,
        phone: selectCustomer.phone,
        address: selectCustomer.address,
        customerType: selectCustomer.customerType,
        name: selectCustomer.name,
        bank: selectCustomer.bank,
        bankcode: selectCustomer.bankcode,
        remark: selectCustomer.remark,
        birthday: selectCustomer.birthday
      };


      if (selectCustomer.name == "") {
        this.$Message.info("名称不能为空");
        return;
      }
      if (selectCustomer.phone == "") {
        this.$Message.info("手机号不能为空");
        return;
      }
      // var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
      // if (!telTest.test(selectCustomer.phone)) {
      //   this.$Message.info("请输入正确的手机号码");
      //   return;
      // }

      this.$Api.updateCustomer(form).then(res => {
        if (res.code == 200) {
          this.editcustomer = false;
          this.$Message.success("保存成功");
          this.getCustomerList();
        }
      });
    },
    formatter (thistime, fmt) {
      let $this = new Date(thistime)
      let o = {
        'M+': $this.getMonth() + 1,
        'd+': $this.getDate(),
        'h+': $this.getHours(),
        'm+': $this.getMinutes(),
        's+': $this.getSeconds(),
        'q+': Math.floor(($this.getMonth() + 3) / 3),
        'S': $this.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }       
  }
};
</script>

<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}

.historyItem {
  width: 350px;
  height: 240px;
  background-color: #ffffff;
  box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
  border-radius: 10px;
  display: inline-block;
  margin: 18px;
  cursor: pointer;
  .typeitem {
    display: block;
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #e5fff7;
    border-radius: 4px;
    border: solid 1px #46bab2;
    position: relative;
    top: -3px;
    right: -3px;
    color: #46bab2;
  }
}
.card {
  overflow: auto;
}

.card > li {
  width: 440px;
  height: 140px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.2);
  margin: 20px;
  padding: 20px 15px 20px 130px;
  line-height: 26px;
  position: relative;
  float: left;
  position: relative;
  .img {
    position: absolute;
    top: 20px;
    left: 15px;
  }

  .butn {
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .datetimePicker {
    width: 100%;
    margin-top: -30.5rem;
    color: red;
    z-index: 10000;  
  }  
}
</style>